
export const initialItemCatgyValue = {
    formula: "yes",
    category_des :"yes",
    online_show :"yes"
}

export const initialItemCatgyValueSuperAdmin = {
    formula: "yes",
    category_des :"yes",
    online_show :"yes"
}